export const GET_MEETING_INSTANCE_OPTIONS = "GET_MEETING_INSTANCE_OPTIONS";
export const SET_MEETING_INSTANCE_OPTIONS = "SET_MEETING_INSTANCE_OPTIONS";
export const REQUEST_MEETING_INSTANCE_CAPTIONS = "REQUEST_MEETING_INSTANCE_CAPTIONS";
export const ALLOW_MEETING_INSTANCE_CAPTIONS = "ALLOW_MEETING_INSTANCE_CAPTIONS";